import React, { useCallback } from 'react';
import AnimateHeight from 'react-animate-height';
import { useAnimationDisplay } from "../../components/accordion/hooks/useAnimationDisplay.js";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
/**
 * Standardized collapsible animation
 * @param open
 * @param ChildrenWrapper
 * @param children
 * @param onAnimationEnd
 * @param props
 * @constructor
 */
export function AnimatedCollapsible({
  open,
  ChildrenWrapper = DefaultWrapper,
  children,
  onHeightAnimationEnd,
  ...props
}) {
  const {
    value: visibleChildren,
    animationEnd
  } = useAnimationDisplay(open ? children : undefined);
  const handleAnimationEnd = useCallback(newHeight => {
    animationEnd();
    onHeightAnimationEnd?.(newHeight);
  }, [animationEnd, onHeightAnimationEnd]);
  return /*#__PURE__*/_jsx(AnimateHeight, {
    height: open && !!visibleChildren ? 'auto' : 0,
    duration: 300,
    easing: "cubic-bezier(0.22, 1, 0.36, 1)",
    onHeightAnimationEnd: handleAnimationEnd,
    ...props,
    children: /*#__PURE__*/_jsx(ChildrenWrapper, {
      children: visibleChildren
    })
  });
}
function DefaultWrapper({
  children
}) {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
}